import { render } from "./ProductCateogryListComponent.vue?vue&type=template&id=6cfc25b5&scoped=true"
import script from "./ProductCateogryListComponent.vue?vue&type=script&lang=js"
export * from "./ProductCateogryListComponent.vue?vue&type=script&lang=js"

import "./ProductCateogryListComponent.vue?vue&type=style&index=0&id=6cfc25b5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfc25b5"],['__file',"resources/js/components/admin/settings/ProductCategory/ProductCateogryListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cfc25b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cfc25b5', __exports__)) {
    api.reload('6cfc25b5', __exports__)
  }
  
  module.hot.accept("./ProductCateogryListComponent.vue?vue&type=template&id=6cfc25b5&scoped=true", () => {
    api.rerender('6cfc25b5', render)
  })

}


export default __exports__